import ReactGA from 'react-ga4';

const trackPage = ({ page, provider }) => {
  ReactGA.send({ hitType: 'pageview', page, provider });
};

let currentPage = '';

export const googleAnalytics = (store) => (next) => (action) => {
  if (action.type === '@@router/LOCATION_CHANGE') {
    const nextPage = `${action.payload.location.pathname}${action.payload.location.search}`;

    if (currentPage !== nextPage) {
      currentPage = nextPage;

      const { appConfiguration: { providerSpecific: { code: provider } = {} } } = store.getState();

      trackPage({ page: nextPage, provider });
    }
  }

  return next(action);
};
